export enum MatchStatus {
    Created = "Created",
    Started = "Started",
    Settled = "Settled",
    Expired = "Expired",
    Ended = "Ended"
}
